// File: theme_settings.tsx
// Description: Builds the MUI ThemeProvider settings (palette and typography) for a given theme mode.

import { ColorsPalletTheme } from "@/constants/colors_pallet_theme"
import { createTheme } from "@mui/material";

// mui theme settings
/**
  * Builds the settings object consumed by MUI's ThemeProvider.
  *
  * @param {string} mode - Theme mode, either "dark" or "light".
  * @returns {object} MUI theme settings (palette and typography) for the given mode.
  */
export const themeSettings = (mode: string):object => {

  const baseTheme = createTheme();

  const colorsPallet = ColorsPalletTheme(mode);

  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
            primary: {
              main: colorsPallet.primary[500],
            },
            secondary: {
              main: colorsPallet.greenAccent[500],
            },
            neutral: {
              main: colorsPallet.gray[500],
              dark: colorsPallet.gray[700],
              light: colorsPallet.gray[100],
            },
            background: {
              default: colorsPallet.primary[500],
            },
          }
        : {
            primary: {
              main: colorsPallet.primary[100],
            },
            secondary: {
              main: colorsPallet.greenAccent[500],
            },
            neutral: {
              main: colorsPallet.gray[500],
              dark: colorsPallet.gray[700],
              light: colorsPallet.gray[100],
            },
            background: {
              default: colorsPallet.default[100],
            },
          }
        ),
    },
    typography: {
      fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
      fontSize: 12,
      h3: {
        fontSize: "2.571rem",
        [baseTheme.breakpoints.down('sm')]: {
          fontSize: '1.5rem',
        },
      },
      h4: {
        fontSize: "1.82rem",
        [baseTheme.breakpoints.down('sm')]: {
          fontSize: '1.3rem',
        },
      },
      h5: {
        fontSize: "1.4rem",
        [baseTheme.breakpoints.down('sm')]: {
          fontSize: '1rem',
        },
      },
      h6: {
        fontSize: "1.2rem",
        [baseTheme.breakpoints.down('sm')]: {
          fontSize: '0.875rem',
        },
      },
      body1: {
        fontSize: "0.875rem",
        [baseTheme.breakpoints.down('sm')]: {
          fontSize: '0.75rem',
        },
      },
      body2: {
        fontSize: "1rem",
        [baseTheme.breakpoints.down('sm')]: {
          fontSize: '0.8rem',
        },
      },
      subtitle2: {
        fontSize: "0.75rem",
        [baseTheme.breakpoints.down('sm')]: {
          fontSize: '0.65rem',
        },
      },
    },
  };
};